// The bundled Windows Hermes crashes in Date.toLocaleString(). Format using
// numeric local-time getters rather than invoking its native locale formatter.
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function formatWindowsMessageDate(value, { now = new Date(), full = false, dateOnly = false } = {}) {
  if (value === null || value === undefined || value === '') return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  const hour = date.getHours(), time = `${hour % 12 || 12}:${String(date.getMinutes()).padStart(2, '0')} ${hour < 12 ? 'AM' : 'PM'}`;
  const sameDay = other => date.getFullYear() === other.getFullYear() && date.getMonth() === other.getMonth() && date.getDate() === other.getDate();
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  const calendar = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  if (dateOnly) return calendar;
  const day = sameDay(now) ? 'Today' : sameDay(yesterday) ? 'Yesterday' : calendar;
  return full ? `${calendar}, ${time}` : `${time} · ${day}`;
}
module.exports = { formatWindowsMessageDate };
